import React, { useState, useEffect, useRef } from "react";
import { authAxios } from "../../config/axios";
import Loader from "../Loader";
import { dashboardMock } from "../../assets/mocks/dashboard.mock";
import { useNavigate, useParams } from "react-router-dom";
import eye from "../../assets/img/eye.svg";
import upload from "../../assets/img/upload.svg";
function Welcome() {
  const [data, setData] = useState(dashboardMock.welcome);
  const [loading, setLoading] = useState(true);
  let { shop } = useParams();
  let navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await authAxios(
          "get",
          `/apisv1/authadmin/pages-and-videos`
        );
        console.log(response.data);
        setData(response.data.data);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleRedirection = (route) => {
    // Redirect to another route
    navigate(`/${shop}/${route}`);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="Polaris-Page--divider transitionEffect">
          <div className="" style={{ display: "flex", gap: "1rem" }}>
            <div className="" style={{ width: "33%" }}>
              <div
                className="Polaris-LegacyCard polaris-welcomeCard"
                style={{ position: "RELATIVE" }}
              >
                <div className="Polaris-LegacyCard__Header">
                  <p className="polaris-card-heading">Total Pages Live On</p>
                  <h2 className="Polaris-Text--root Polaris-Text--heading3xl">
                    {data.pages < 10 ? `0${data.pages}` : data.pages}
                  </h2>
                </div>
                <div className="">
                  <button
                    onClick={() => handleRedirection("pages")}
                    className="Polaris-Button "
                    type="button"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {/* <img src={eye} alt="eye icon" />
                     */}
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: "none" }}
                    >
                      <g clip-path="url(#clip0_487_18507)">
                        <path
                          d="M3 9.99984C3 9.99984 5.66667 4.6665 10.3333 4.6665C15 4.6665 17.6667 9.99984 17.6667 9.99984C17.6667 9.99984 15 15.3332 10.3333 15.3332C5.66667 15.3332 3 9.99984 3 9.99984Z"
                          stroke="#883DCF"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.3334 12C11.4379 12 12.3334 11.1046 12.3334 10C12.3334 8.89543 11.4379 8 10.3334 8C9.2288 8 8.33337 8.89543 8.33337 10C8.33337 11.1046 9.2288 12 10.3334 12Z"
                          stroke="#883DCF"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_487_18507">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(2.33337 2)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <span className="Polaris-Button__Content">
                      <span className="Polaris-Button__Text dashboard-btn">
                        View All
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="" style={{ width: "33%" }}>
              <div
                className="Polaris-LegacyCard polaris-welcomeCard"
                style={{ position: "RELATIVE" }}
              >
                {/* <span
                  className="Polaris-Badge Polaris-Badge--statusInfo"
                  style={{ position: "ABSOLUTE", right: "15px", top: "15px" }}
                >
                  <span className="Polaris-Text--root Polaris-Text--bodySm">
 videos
                  </span>
                </span> */}
                <div className="Polaris-LegacyCard__Header">
                  <p className="polaris-card-heading">Total Videos Uploaded</p>
                  <h2 className="Polaris-Text--root Polaris-Text--heading3xl">
                    {data.videos}
                  </h2>
                </div>
                <div className="">
                  <button
                    onClick={() => handleRedirection("media")}
                    className="Polaris-Button"
                    type="button"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: "none" }}
                    >
                      <path
                        d="M16.4165 11.25V14.25C16.4165 14.6478 16.2585 15.0294 15.9772 15.3107C15.6959 15.592 15.3143 15.75 14.9165 15.75H4.4165C4.01868 15.75 3.63715 15.592 3.35584 15.3107C3.07454 15.0294 2.9165 14.6478 2.9165 14.25V11.25"
                        stroke="#883DCF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.4165 6L9.6665 2.25L5.9165 6"
                        stroke="#883DCF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.6665 2.25V11.25"
                        stroke="#883DCF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    {/* <img src={upload} alt="upload" /> */}
                    <span className="Polaris-Button__Content">
                      <span className="Polaris-Button__Text dashboard-btn">
                        Upload Video
                      </span>
                    </span>
                  </button>
                </div>
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="100%"
                  height={42}
                  viewBox="0 0 150% 42"
                  fill="none"
                >
                  <rect
                    x="0.970703"
                    width="100%"
                    height={42}
                    rx={5}
                    fill="url(#pattern0)"
                  />
                  <defs>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width={1}
                      height={1}
                    >
                      <use
                        xlinkHref="#image0_1929_18816"
                        transform="matrix(0.00330033 0 0 0.0268741 0 -0.213343)"
                      />
                    </pattern>
                    <image
                      id="image0_1929_18816"
                      width={303}
                      height={46}
                      xlinkHref="data:image/png;base64,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"
                    />
                  </defs>
                </svg> */}
              </div>
            </div>
            <div className="" style={{ width: "33%" }}>
              <div
                className="Polaris-LegacyCard polaris-welcomeCard"
                style={{ position: "RELATIVE" }}
              >
                {/* <span
                  className="Polaris-Badge Polaris-Badge--statusInfo"
                  style={{ position: "ABSOLUTE", right: "15px", top: "15px" }}
                >
                  <span className="Polaris-Text--root Polaris-Text--bodySm">
 videos
                  </span>
                </span> */}
                <div className="Polaris-LegacyCard__Header">
                  <p className="polaris-card-heading">
                    Customised your videos{" "}
                  </p>
                  <h2
                    className="Polaris-Text--root Polaris-Text--heading3xl"
                    style={{ visibility: "hidden" }}
                  >
                    {data.videos}
                  </h2>
                </div>
                <div className="">
                  <button
                    onClick={() => handleRedirection("customise")}
                    className="Polaris-Button "
                    type="button"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: "none" }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.58309 2.5C3.4325 2.5 2.49976 3.43274 2.49976 4.58333V7.08333C2.49976 8.23393 3.4325 9.16667 4.58309 9.16667H7.08309C8.23368 9.16667 9.16642 8.23393 9.16642 7.08333V4.58333C9.16642 3.43274 8.23368 2.5 7.08309 2.5H4.58309ZM7.08309 4.16667H4.58309C4.35297 4.16667 4.16642 4.35321 4.16642 4.58333V7.08333C4.16642 7.31345 4.35297 7.5 4.58309 7.5H7.08309C7.31321 7.5 7.49976 7.31345 7.49976 7.08333V4.58333C7.49976 4.35321 7.31321 4.16667 7.08309 4.16667Z"
                        fill="#883DCF"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.9164 10.8333C11.7658 10.8333 10.8331 11.7661 10.8331 12.9167V15.4167C10.8331 16.5673 11.7658 17.5 12.9164 17.5H15.4164C16.567 17.5 17.4998 16.5673 17.4998 15.4167V12.9167C17.4998 11.7661 16.567 10.8333 15.4164 10.8333H12.9164ZM12.9164 12.5C12.6863 12.5 12.4998 12.6865 12.4998 12.9167V15.4167C12.4998 15.6468 12.6863 15.8333 12.9164 15.8333H15.4164C15.6465 15.8333 15.8331 15.6468 15.8331 15.4167V12.9167C15.8331 12.6865 15.6465 12.5 15.4164 12.5H12.9164Z"
                        fill="#883DCF"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.49976 12.9167C2.49976 11.7661 3.4325 10.8333 4.58309 10.8333H7.08309C8.23368 10.8333 9.16642 11.7661 9.16642 12.9167V15.4167C9.16642 16.5673 8.23368 17.5 7.08309 17.5H4.58309C3.4325 17.5 2.49976 16.5673 2.49976 15.4167V12.9167ZM4.58309 12.5H7.08309C7.31321 12.5 7.49976 12.6865 7.49976 12.9167V15.4167C7.49976 15.6468 7.31321 15.8333 7.08309 15.8333H4.58309C4.35297 15.8333 4.16642 15.6468 4.16642 15.4167V12.9167C4.16642 12.6865 4.35297 12.5 4.58309 12.5Z"
                        fill="#883DCF"
                      />
                      <path
                        d="M14.1664 2.91667C14.6267 2.91667 14.9998 3.28976 14.9998 3.75V5H16.2498C16.71 5 17.0831 5.3731 17.0831 5.83333C17.0831 6.29357 16.71 6.66667 16.2498 6.66667H14.9998V7.91667C14.9998 8.3769 14.6267 8.75 14.1664 8.75C13.7062 8.75 13.3331 8.3769 13.3331 7.91667V6.66667H12.0831C11.6229 6.66667 11.2498 6.29357 11.2498 5.83333C11.2498 5.3731 11.6229 5 12.0831 5H13.3331V3.75C13.3331 3.28976 13.7062 2.91667 14.1664 2.91667Z"
                        fill="#883DCF"
                      />
                    </svg>

                    <span className="Polaris-Button__Content">
                      <span className="Polaris-Button__Text dashboard-btn">
                        Customisation
                      </span>
                    </span>
                  </button>
                </div>
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="100%"
                  height={42}
                  viewBox="0 0 150% 42"
                  fill="none"
                >
                  <rect
                    x="0.970703"
                    width="100%"
                    height={42}
                    rx={5}
                    fill="url(#pattern0)"
                  />
                  <defs>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width={1}
                      height={1}
                    >
                      <use
                        xlinkHref="#image0_1929_18816"
                        transform="matrix(0.00330033 0 0 0.0268741 0 -0.213343)"
                      />
                    </pattern>
                    <image
                      id="image0_1929_18816"
                      width={303}
                      height={46}
                      xlinkHref="data:image/png;base64,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"
                    />
                  </defs>
                </svg> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Welcome;
